const ATS_EMBED_CONTEXT_KEY = 'atsEmbedContext';
const PREFILLED_JOB_ID_KEY = 'atsEmbedPrefilledJobId';

export type AtsEmbedContext = {
  instanceId: string;
  organizationId: string;
  jobId: string | null;
};

export type FrameCheckWindow = { self: unknown; top: unknown };

const isFramed = (currentWindow: FrameCheckWindow): boolean => {
  try {
    return currentWindow.self !== currentWindow.top;
  } catch {
    return true;
  }
};

export const startAtsEmbed = (context: AtsEmbedContext): void => {
  try {
    sessionStorage.removeItem(PREFILLED_JOB_ID_KEY);
    sessionStorage.setItem(ATS_EMBED_CONTEXT_KEY, JSON.stringify(context));
  } catch {
    // Storage can be blocked in a third-party frame; Classic then shows its normal navbar.
  }
};

// Other hosts frame Classic too. Only a session that entered through /ats is embedded.
export const getAtsEmbedContext = (
  currentWindow: FrameCheckWindow = window
): AtsEmbedContext | null => {
  if (!isFramed(currentWindow)) return null;

  try {
    const stored: unknown = JSON.parse(
      sessionStorage.getItem(ATS_EMBED_CONTEXT_KEY) ?? 'null'
    );
    if (
      typeof stored !== 'object' ||
      stored === null ||
      !('instanceId' in stored) ||
      typeof stored.instanceId !== 'string' ||
      !('organizationId' in stored) ||
      typeof stored.organizationId !== 'string'
    ) {
      return null;
    }
    const jobId =
      'jobId' in stored && typeof stored.jobId === 'string'
        ? stored.jobId
        : null;
    return {
      instanceId: stored.instanceId,
      organizationId: stored.organizationId,
      jobId
    };
  } catch {
    return null;
  }
};

// Candidates remounts on route changes; the description fills the box once per entry from Bullhorn.
export const markJobDescriptionPrefilled = (jobId: string): void => {
  try {
    sessionStorage.setItem(PREFILLED_JOB_ID_KEY, jobId);
  } catch {
    // Without storage the description can fill the box again after a remount.
  }
};

export const isJobDescriptionPrefilled = (jobId: string): boolean => {
  try {
    return sessionStorage.getItem(PREFILLED_JOB_ID_KEY) === jobId;
  } catch {
    return false;
  }
};
